import common from "@page/common/js/common";
import store from "@global/components/store/index.js";
import shopContentApp from "@page/shopContent/js/index.vue";

require("@global/vendors/jquery.sticky-kit");

window.cartAddonSlide = {
	infinite: true,
	slidesToShow: 3,
	slidesToScroll: 3,
	dots: true,
	speed: 800,
	prevArrow: ".addon-arrow-left",
	nextArrow: ".addon-arrow-right",
	responsive: [
		{
			breakpoint: 576,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 2,
				arrows: false,
			},
		},
	],
};

new Vue({
	el: "#shop-content",
	store,
	components: {
		shopContentApp,
	},
	template: `<div>
		<shop-content-app />
	</div>`,
});
